export const constants = {
  app_settings: {
    formats: {
      default_date_format: 'YYYY-MM-DD',
      long_date_format: 'MMMM d, y',
      default_date_time_format: "MMM d, y 'at' hh:mm a",
      select_option: '-Select-',
    },
    validation_message: {
      SINGLE_CHOICE: 'Select an option.',
      IS_REQUIRED: 'Required field',
      POSITIVE_NUMBER_ONLY: 'Number cannot be negative or fractional.',
      LESS_THAN_FUNDED_BEDS_COUNT:
        'Open bed (no referral) count exceeds funded beds',
    },
  },
};
